import { useForm } from "react-hook-form";
import { useGetPipelineInfoQuery, useUpdatePipelineMutation } from "../api/pipelineApi";
import { EditStages } from "../components/PipelineComponents/EditComponents/EditStages";
import { Link } from "react-router";
import { Pipeline } from "../types/pipeline";
import { isFetchBaseQueryError, parseErrorToDetailProblem } from "../utils/errorHelpers";
import { CircularProgress } from "@mui/joy";
import { ErrorMessage } from "../components/UtilitiesComponents/ErrorMessage";
import { useState } from "react";

export function EditPipeline() {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { data: pipelineInfo } = useGetPipelineInfoQuery("Activa", { refetchOnMountOrArgChange: true });
    const [updatePipeline, { isLoading }] = useUpdatePipelineMutation();
    const stage = pipelineInfo?.stages.find(stage => stage.isDefaultStage == true);
    const pipelineDefaultData = {
        defaultStage: stage ? stage.id : 0
    }
    const {
        register,
        handleSubmit,
        reset,
        formState: { isDirty },
    } = useForm<Pipeline>({
        defaultValues: {
            defaultStage: 0,
        },
        values: pipelineDefaultData
    });

    const submitUpdatePipeline = handleSubmit(async (data: Pipeline) => {
        try {
            await updatePipeline({ ...data, pipelineId: 1 }).unwrap();
            reset(data);
        } catch (error) {
            if(isFetchBaseQueryError(error)) {
                const problemDetails = parseErrorToDetailProblem(error);
                if(problemDetails)
                    setErrorMessage(problemDetails.title);
            }
        }
    });

    const resetErrorMessage = () => setErrorMessage(null);

    return (
        <div className="w-full h-full">

            <div className="border-0 border-purple-800 mx-2 px-2 py-1 my-1 flex justify-between items-center">
                <div>
                    <form onSubmit={submitUpdatePipeline} autoComplete="off">
                        <p className="text-lg font-semibold">Edición del embudo</p>
                        <div className="flex items-center">
                            <label className="text-sm font-semibold w-[250px]">Etapa por defecto</label>
                            <select 
                                {...register("defaultStage")}
                                className="
                                    w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                    font-semibold text-gray-600 text-sm">
                                <option value={0} hidden>Seleccionar etapa</option>
                                {pipelineInfo?.stages.map((stage, index) => (
                                    <option key={index} value={stage.id}>{stage.nombre}</option>
                                ))}
                            </select>
                        </div>

                        {errorMessage && (
                            <ErrorMessage 
                            customMessage>
                                <p className="text-sm">{errorMessage}</p>
                            </ErrorMessage>)}

                        {isDirty && (
                        <>
                        <div className="flex gap-x-2 justify-center py-2">
                        {isLoading
                            ? 
                            <CircularProgress sx={{ 
                                height: 27,
                                width: 27,
                                "--CircularProgress-size": "25px",
                                "--CircularProgress-trackThickness": "4px",
                                "--CircularProgress-progressThickness": "4px"
                            }}/>
                            :
                            <>
                            <button 
                                type="submit"
                                className="bg-green-800 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center">
                                <p className="text-white text-[13px] font-semibold text-center">Guardar</p>
                            </button>
                            <button 
                                onClick={() => {
                                    reset();
                                    resetErrorMessage();
                                }}
                                className="border-2 border-gray-300 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center hover:bg-gray-100">
                                <p className="text-gray-600 text-[13px] font-semibold text-center">Cancelar</p>
                            </button>
                            </>
                        }
                        </div>
                        </>)}
                    </form>
                </div>

                <Link to={"/pipeline"}>
                    <button 
                        className="border-2 border-gray-300 rounded-[3px] px-[6px] py-[2px] h-[30px] flex gap-1 items-center hover:bg-gray-100">
                        <p className="text-gray-600 text-[13px] font-semibold text-center">Terminar</p>
                    </button>
                </Link>
            </div>

            <div className={`border-0 border-green-800 m-2 h-full grid ${`grid-cols-5`} gap-2 p-2`}>
                {pipelineInfo?.stages.map((stage, index) => (
                    <EditStages 
                        key={index}
                        stage={stage}/>
                ))}
            </div>

        </div>
    );
}